module.exports = __webpack_public_path__ + "static/media/cr-bg.53a92993.png";